// extracted by mini-css-extract-plugin
export default {"wrap":"MicrositeDeviceBreakdown_wrap__waUNr","empty":"MicrositeDeviceBreakdown_empty__Aa+JH"};